<template>
  <transition name='modal'>
    <div class='modal-mask close-modal-token' @click="closeModal">
      <div class="modal-container">
        <div class="header">
          Change User Options
          <i class="fa fa-times close-modal-token"></i>
        </div>
        <div class="body">

          <div class='avatar-wrapper mb-2'>

            <!-- <div class='avatar-mini-wrapper'> -->

              <span v-if='hasAvatar' class='avatar-delete fa fa-times-circle' @click='clearAvatar'></span>

              <div class='op-avatar' title='Click to change Avatar' @click='changeAvatar'>
                <avatar :username="username" :src="avatarUrl" :rounded="false" :size="120" class="picture"></avatar>
                <span class='fas fa-camera'></span>
                <input ref='avatarUpload' type="file" accept=".jpg, .jpeg, .png, .webp, .gif" style="display: none;"
                  @change='changeFile'>
              </div>

            <!-- </div> -->
          </div>

          <div class="op-edit">
            <table class='mb-2'>
              <tbody>

                <tr v-for='(t,index) in tableData' :key='index'>
                  <td>{{t.name}}:</td>
                  <td>
                    <input :type='inputType(t)' v-model.trim="t.value" :class='{"invalid":inputType(t)==="password" && passNotMatched}' />
                  </td>
                </tr>

                <tr>
                  <td> Email Notifications:</td>
                  <td>
                    <b-form-checkbox id="checkbox1" v-model="emailNotif" value='1' unchecked-value="0"></b-form-checkbox>
                  </td>
                </tr>

                <tr>
                  <td>Change Theme:</td>
                  <td>
                    <span class='theme-changer' title='Click to switch themes' @click='changeTheme' :class='{darkTheme : darkTheme}'></span>
                  </td>
                </tr>
                <!-- <tr :style='{visibility:!passNotMatched?"hidden":"visible"}' style='color: red'>Passwords do not match.</tr> -->
              </tbody>
            </table>

            <span class='op-action'>
              <div>
                <span></span>
              </div>
              <button @click='closeModal' class="btn btn-danger ml-2 close-modal-token">
                <i class="fa fa-times"></i> Cancel</button>
              <button @click='editChanges' class="btn btn-primary ml-2" :disabled='passNotMatched'>
                <i class="fa fa-save"></i> Save</button>
            </span>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { store } from "@/store/index.js";
import { mapState } from "vuex";
import { baseURL } from "@/api/config.js";
import { api } from "@/api/index";
import Avatar from "vue-avatar";

export default {
  components: {
    Avatar
  },
  props: ["userOptionsVisible"],
  data() {
    return {
      avatarUrl: "",
      pendingDeleteAvatar: false,
      emailNotif: "0",
      tableData: [
        {
          name: "Name",
          value: ""
        },
        {
          name: "Surname",
          value: ""
        },
        {
          name: "Email",
          value: ""
        },
        {
          name: "Password",
          type: "password",
          value: ""
        },
        {
          name: "Confirm Password",
          type: "password",
          value: ""
        }
        // {
        //   name: "Email Notifications",
        //   type: "checkbox",
        //   value: ""
        // }
      ],
      avatarInputData: undefined,
      avatarInputPath: "",
      avatarHeader: {
        "content-type": "multipart/form-data"
      }
    };
  },
  computed: {
    ...mapState({
      darkTheme: "darkTheme",
      userStorage: "userStorage"
    }),
    hasAvatar() {
      let a = this.avatarUrl;
      return a !== undefined && a !== null && a !== "";
    },
    passNotMatched() {
      let a = this.tableData[3].value;
      let b = this.tableData[4].value;
      let empty = a.length === 0 || b.length === 0;
      let match = a === b;
      return !empty && !match;
    },
    username() {
      return this.userStorage.name + " " + this.userStorage.surname;
    }
  },
  created() {
    this.setAvatarLink();
    if (this.userStorage.email !== localStorage.email) {
      store.commit("localStorage", {
        name: localStorage.name,
        surname: localStorage.surname,
        email: localStorage.email
      });
    }
    this.tableData[0].value = this.userStorage.name;
    this.tableData[1].value = this.userStorage.surname;
    this.tableData[2].value = this.userStorage.email;
    let localEmailNotif = localStorage.emailNotif;
    if (localEmailNotif) {
      this.emailNotif = localEmailNotif;
    }
  },
  methods: {
    inputType(tData) {
      if (!tData.type) return "text";
      return tData.type;
    },
    async editChanges() {
      // UPLOAD AVATAR
      if (this.avatarInputData !== undefined) {
        this.avatarUpload();
      } else if (this.pendingDeleteAvatar) {
        this.deleteAvatar();
      }
      let objToSend = this.tableData;
      objToSend[4] = this.emailNotif;
      // CHANGE DATA
      try {
        this.closeModal("close-modal-token");
        let res = await api.editUserOptions(objToSend);

        if (!res) return;
        if (res.data.status === "OK") {
          store.commit("toastStatus", {
            message: "Success"
          });
          store.commit("localStorage", {
            name: this.tableData[0].value,
            surname: this.tableData[1].value,
            email: this.tableData[2].value,
            emailNotif: this.emailNotif
          });
        }
      } catch (e) {
        console.log("e: " + e);
      }
    },
    clearAvatar() {
      this.avatarUrl = "";
      this.pendingDeleteAvatar = true;
      this.avatarInputData = undefined;
    },
    deleteAvatar() {
      api.deleteAvatar().catch(e => {
        console.log("e: " + e);
      });
    },
    changeAvatar() {
      // FIRES 'CHANGE FILE' EVENT
      this.$refs.avatarUpload.click();
    },
    changeFile(e) {
      if (e.target.files.length === 0) return;
      this.avatarInputData = e.target.files[0];
      // PREVIEW LOCAL AVATAR
      let oFReader = new FileReader();
      oFReader.readAsDataURL(e.target.files[0]);
      oFReader.onload = oFREvent => {
        this.avatarUrl = oFREvent.target.result;
        // this.hasAvatar = true;
      };
      // CLEAR INPUT FILE CACHE
      e.target.value = null;
    },
    async avatarUpload() {
      let file = this.avatarInputData;
      let fd = new FormData();
      fd.append("img", file);
      let res = await api.editUserAvatar(fd);
      if (!res) return;
      if (res.data.status !== "OK") {
        store.commit("modalError", {
          active: true,
          message: "Avatar not uploaded properly."
        });
      }
      // else {
      //   this.setAvatarLink();
      // }
    },
    async setAvatarLink() {
      let link = `auth/users/img?sid=${
        window.localStorage.sid
      }&crypt=${Date.now()}`;

      let res = await api.hasAvatar();
      if (!res) return;
      if (res.data.data === 1) {
        this.avatarUrl = baseURL + link;
      } else {
        this.avatarUrl = "";
      }
      //res.data["unset key"] === null
    },
    closeModal(val) {
      let token = "close-modal-token";
      if (val === token || val.target.classList.contains(token)) {
        this.$emit("userOptionsVisible", false);
      }
    },
    changeTheme() {
      // this.themePendingChange = true;
      localStorage.dark = !this.darkTheme;
      store.commit("darkTheme", !this.darkTheme);
    }
  }
};
</script>

<style scoped>
.modal-mask {
  background: rgba(16, 16, 16, 0.76);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}

.modal-container {
  display: flex;
  flex-direction: column;
  margin: 0 10px 0 80px;
  transition: all 0.3s ease;
}

.modal-container .header {
  color: white;
  background: var(--ac-color);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  border-radius: 5px 5px 0 0;
}

.modal-container .header i {
  cursor: pointer;
}

.modal-container .body {
  position: relative;
  background: #f4f4f4;
  border: 1px solid #777;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: 400px;
  border-radius: 0 0 5px 5px;
}

.vue-avatar--wrapper.picture {
  font: 70px Saira !important;
}

.avatar-wrapper {
  display: flex;
  flex-direction: column;
  align-content: center;
  background: rgba(255, 255, 255, 0.66);
  height: 170px;
  border-radius: 0.5rem;
}

.op-avatar {
  position: relative;
  cursor: pointer;
  margin: auto 20px;
  width: 120px;
}

.op-avatar .fa-camera {
  position: absolute;
  opacity: 0;
  font-size: 35px;
  top: 50%;
  left: 50%;
  transition: 0.3s ease;
  transform: translate(-50%, -50%);
}

.op-avatar .picture {
  height: 120px;
  display: flex;
  margin: auto;
  border-radius: 5px !important;
  transition: 0.5s ease;
  backface-visibility: hidden;
  width: 120px;
}

.op-avatar:hover .picture {
  opacity: 0.3;
}

.op-avatar:hover span {
  opacity: 1;
  color: #444;
  font-size: 40px;
}

.avatar-delete {
  cursor: pointer;
  color: var(--red);
  margin-top: 10px;
  z-index: 1;
  text-align: center;
}

.op-edit {
  align-self: center;
}

.op-edit tr {
  margin-bottom: 5px;
}

.op-edit td {
  padding-bottom: 7px;
  padding-left: 5px;
}

.op-edit input {
  border: none;
  border-bottom: 1px solid rgba(119, 119, 119, 0.47);
  background: #f4f4f4;
  padding: 4px 10px;
  width: 100%;
}

.op-edit input.invalid {
  border: 1px solid red;
  height: 30px;
  width: 100%;
}

.op-edit input:disabled {
  user-select: none;
}

.op-action {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.op-action button {
  padding: 4px 12px;
}

.theme-changer.darkTheme {
  background: var(--main-bg-color);
}

.theme-changer.darkTheme:hover {
  background: rgba(228, 228, 228, 0.7);
}

.theme-changer {
  cursor: pointer;
  display: block;
  border-radius: 50%;
  border: 2px solid rgba(43, 123, 216, 0.6);
  box-shadow: 0 0 2px rgba(43, 123, 216, 0.6);
  background: var(--sec-bg-color);
  margin-right: 15px;
  width: 30px !important;
  height: 30px;
}

.op-action .fa {
  margin: 5px 10px 5px 0;
}

.btn-danger {
  color: #d01a0d;
  background-color: transparent;
  border-color: #dc3545;
}

/* MODAL TRANSITION */
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1.1);
}

@media screen and (min-width: 600px) {
  .modal-container .body {
    max-width: unset;
  }

  .modal-container {
    margin: unset;
  }

  .avatar-delete {
    transform: scale(1.2);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Misc/UserOptions.vue